<div>
  <button class="btn btn-{{ type }} btn-enjochem" (click)="handleClick()">
    <i class="{{ icon }}"></i>
    <span>{{ label }}</span>
  </button>
</div>
